/**
 * Reducción de luz azul: nivel de intensidad (porcentaje) y tinte cálido que se multiplica sobre la
 * pantalla (.ichtys-blue-light en theme.css). El rojo queda fijo; el verde y sobre todo el azul bajan
 * en proporción al nivel. Al 50 % el tinte es #ffe4b9 (azul ×0,73, verde ×0,89), al 100 % #ffc873
 * (azul ×0,45, verde ×0,78), parecido a la "luz nocturna" del sistema al máximo.
 */
export const BLUE_LIGHT_MIN_LEVEL = 10;
export const BLUE_LIGHT_MAX_LEVEL = 100;
export const BLUE_LIGHT_LEVEL_STEP = 10;
export const DEFAULT_BLUE_LIGHT_LEVEL = 50;

const GREEN_AT_MAX = 200;
const BLUE_AT_MAX = 115;

export const clampBlueLightLevel = (value: unknown): number => {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return DEFAULT_BLUE_LIGHT_LEVEL;
  return Math.min(BLUE_LIGHT_MAX_LEVEL, Math.max(BLUE_LIGHT_MIN_LEVEL, Math.round(n)));
};

const hex = (n: number): string => Math.round(n).toString(16).padStart(2, '0');

/** Color del velo para un nivel (10..100). */
export const blueLightTint = (level: number): string => {
  const ratio = clampBlueLightLevel(level) / BLUE_LIGHT_MAX_LEVEL;
  const green = 255 - (255 - GREEN_AT_MAX) * ratio;
  const blue = 255 - (255 - BLUE_AT_MAX) * ratio;
  return `#ff${hex(green)}${hex(blue)}`;
};
